import Flickity from 'flickity';
import HeroComponent from '../components/hero';
import Clouds from '../modules/Clouds';
import YouTubeEmbedAPI from '../modules/YouTubeEmbedAPI';

export default class HomeController {

  constructor(options) {
    this.options = options;
    console.log('HOME CONTROLLER');

    this.clouds = new Clouds({ num:10, elem:$('div.home__nutrition__clouds') });

    // this.home_hero = new HeroComponent({
    //   elem      :'section.home__hero',
    //   parallaxCopy : true,
    // });

    this.home_products = new HeroComponent({
      elem      :'section.home__products'
    });

    // this.home_nutrition = new HeroComponent({
    //   elem      :'section.home__nutrition'
    // });

    // this.home_nutrition = new HeroComponent({
    //   elem      :'section.home__contest',
    // });

    this.home_recipes = new HeroComponent({
      elem      :'section.home__recipes'
    });

    // this.home_csr = new HeroComponent({
    //   elem      :'section.home__csr'
    // });

    if (window.location.hash === '#altimage') {
      // $('.home__hero').removeClass('alt-image cmpnt__hero--bottom');
      // $('.supportnav__logo').addClass('alt-image');
    }

    this.transitionIn();
    this.updateUI();

    // track the scroll position
    $(window).scroll( e => this.handleScroll(e) );

    this.YTE = new YouTubeEmbedAPI();

    $('.is-video').click( (e) => {
      e.preventDefault();

      $('div.site__overlay').addClass('is-active');
      $('div.modal').addClass('is-active');

      const videoID = $(e.currentTarget).data('videoid');
      console.log(videoID, $(e.currentTarget));
      this.YTE.createPlayer(videoID);
    });

    $('div.modal').click( (e) => {

      if ( $(e.target).hasClass('modal') ||
        $(e.target).hasClass('modal__close') ) {

        $('div.site__overlay').removeClass('is-active');
        $('div.modal').removeClass('is-active');

        if (this.YTE) {
          this.YTE.destroyPlayer();
        }
      }

    });

    if ( $('div.home__newslidebanners')[0] ) {
      this.flkty = new Flickity('div.home__newslidebanners', {
        prevNextButtons: true,
        wrapAround: true,
          pageDots: false,
          autoPlay: 4000,
        arrowShape: 'M71.09,7a6.62,6.62,0,0,1,4.82,11.14L47.24,48.69,76.37,82a6.62,6.62,0,0,1-10,8.71l-37-42.37L66.27,9.09A6.6,6.6,0,0,1,71.09,7Z',
      });

      if (this.flkty.cells.length < 1) {
        this.flkty.destroy();
        this.flkty = new Flickity('div.home__newslidebanners', {
          // prevNextButtons: false,
          wrapAround: false,
        });
      }
    }

    this.flkty_sections = new Flickity('.home__sections__carousel', {
        prevNextButtons: false,
        wrapAround: true,
        autoPlay: false,
        pageDots: false,
        arrowShape: 'M71.09,7a6.62,6.62,0,0,1,4.82,11.14L47.24,48.69,76.37,82a6.62,6.62,0,0,1-10,8.71l-37-42.37L66.27,9.09A6.6,6.6,0,0,1,71.09,7Z',
        on: {
          ready: function() {
            console.log('Flickity is ready');
          },
          change: function( index ) {
            console.log( 'Slide changed to' + index );
          }
        }
    });

    this.flkty_nav = new Flickity('.home__sections__nav', {
        contain:true,
        prevNextButtons: true,
        wrapAround: false,
        autoPlay: false,
        pageDots: false,
        arrowShape: {
          x0: 10,
          x1: 60, y1: 50,
          x2: 60, y2: 40,
          x3: 60
        },
        cellAlign: 'left'
    });

    $('.home__sections__nav .carousel-cell button').on('click', function(){
      $('.home__sections__nav .carousel-cell button').removeClass('selected');
      var index = $(this).data('index');
      $(this).addClass('selected')
      Flickity.data('.home__sections__carousel').select(index)
      //flkty_sections( 'select', 3 );

    });


    // Timeline
var mainAnimations = [];

/*
 Animation for Scene 1, docs
 */

var staggerTime = 0.3;

var timeline = new TimelineLite( {paused: true, onComplete: function(){

  $( ".photos img" ).each(function(  ) {

    var current = Number($(this).attr('data-position'));
    var next = current + 1;
    if(current == 8){
      next = 1;
    }
    $(this).attr('data-position', next)
    // console.log($(this).attr('data-position')  );
  });

  $( ".photos img" ).each(function(  ) {

    var current = Number($(this).attr('data-position'));

    $(this).appendTo(".item" + current);

  });

  mainAnimations['#scene1'].restart();
} } );


// timeline.insert( TweenMax.set($(".cwhome"), {css: { scaleY: 0, force3D:false }}));

timeline.insert( TweenMax.staggerTo($(".dine .band"), 1.5, {css: { scaleY: 0, force3D:false }}, staggerTime), 0 );
timeline.insert( TweenMax.to({}, 4, {}), 1.5 );

mainAnimations['#scene1'] = timeline;

mainAnimations['#scene1'].play();

var staggerTime2 = 0.3;

var timeline2 = new TimelineLite( {paused: false } );

timeline2.insert( TweenMax.staggerFrom($(".text .s"), 0.3, {css: { autoAlpha:0 }}, staggerTime), 0 );




mainAnimations['#scene2'] = timeline2;

// mainAnimations['#scene2'].play();

/*
var currentImg = undefined,
    currentImgProps = {x:0, y:0},
    isZooming = false,
    column = -1,
    mouse = {x:0, y:0},
    delayedPlay,
    boxContainers = [];

for (var i=0; i<12; i++){

    if (i%4===0) column++;

    var b = document.createElement('div');
    $('.mainBoxes').append(b);
    boxContainers.push(b);

    gsap.set(b, {
      attr:{ id:'b'+i, class:'photoBox pb-col'+column },
      backgroundImage:'url(https://assets.codepen.io/721952/'+i+'.jpg)',
      backgroundSize:'cover',
      backgroundPosition:'center',
      overflow:'hidden',
      x:[60,280,500][column],
      width:400,
      height:640,
      borderRadius:20,
      scale:0.5,
      zIndex:1
    });

    b.tl = gsap.timeline({paused:true, repeat:-1})
      .fromTo(b, {y:[-575,800,800][column], rotation:-0.05}, {duration:[40,35,26][column], y:[800,-575,-575][column], rotation:0.05, ease:'none'})
      .progress(i%4/4)
}



function playBoxes() {
  for (var i = 0; i < boxContainers.length; i++) {
    var tl = boxContainers[i].tl;
    tl.play();
    gsap.to(tl, {
      duration: 0.4,
      timeScale: 3,
      ease: 'sine.in',
      overwrite: true
    });
  }
}


window.onload = function(){

  var _tl = gsap.timeline({onStart:playBoxes})
      .set('.dine .main',        {perspective:800})
      .set('.dine .photoBox',    {opacity:1, cursor:'pointer'})
      .set('.dine .mainBoxes',   {left:'75%', xPercent:-50, width:1200, rotationX:14, rotationY:-15, rotationZ:10})
      .fromTo('.dine .main',     {autoAlpha:0},{duration:0.6, ease:'power2.inOut', autoAlpha:1}, 0.2)


  if ( !!('ontouchstart' in window) ) { console.log('touch device!')
    mouse.x = window.innerWidth-50;
    mouse.y = 60;
  }
  else {
    $('.main').on('mousemove', function (e){
      mouse.x = e.x;
      mouse.y = e.layerY;
    });
  }

}
*/
  }

  transitionIn() {

    // reveal the home hero text
    // $('.home__hero .cmpnt__hero__copy__cntr').addClass('do-intro');

    setTimeout( () => {
      // $('.home__hero .cmpnt__hero__copy__cntr').removeClass('do-intro start-intro');
    }, 2300);

  }

  updateUI() {
    const st = $(window).scrollTop();
    const trig1 = $(window).height() * 0.75;
    const trig2 = $(window).height() * 0.35;
    // const trig3 = $(window).height() * 0.15;

    if ( $('.home__products').offset().top - st < trig1 && !$('.home__products').hasClass('has-animated') ) {
      $('.home__products').addClass('has-animated');
    }

    // $('.home__products__col').each( (i, v) => {
    //   if ( $(v).offset().top - st < trig2 && !$(v).hasClass('has-animated') ) {
    //     $(v).addClass('has-animated');
    //   }
    // });

    // if ( $('.home__nutrition').offset().top - st < trig2 && !$('.home__nutrition__scene').hasClass('do-transition') ) {
    //   $('.home__nutrition__scene').addClass('do-transition');
    // }
  }

  handleScroll() {
    this.updateUI();
  }

}



// WEBPACK FOOTER //
// ./js/controllers/pages/HomeController.js